import { createStyles } from '@material-ui/core/styles';

const styles = createStyles((theme) => ({
  form: {
    width: '100%',
    backgroundColor: '#fff',
    position: 'absolute',
    bottom: 0,
    borderTop: '1px solid #e0e0e0',
    boxShadow: '0 -2px 10px rgba(0,0,0,0.05)',
  },
  inputSubmit: {
    marginTop: '10px',
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '24px',
      '&:hover': {
        backgroundColor: '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: '#ffffff',
      }
    }
  },
  btnSubmit: {
    marginTop: '5px',
    borderRadius: '50%',
    minWidth: '48px',
    height: '48px',
    marginLeft: '10px',
    '&:hover': {
      color: '#5568d3',
    },
    '&:disabled': {
      backgroundColor: '#e0e0e0',
    }
  },
  boxChat: {
    width: '375px',
    height: '477px',
    backgroundColor: '#FFFFFF',
    position: 'fixed',
    right: '65px',
    bottom: '55px',
    zIndex: '9999',
    boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.2)',
    borderRadius: '12px',
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      width: '320px',
      right: '25px'
    },
    '@media(max-width: 355px)': {
      width: '300px',
      right: '10px'
    },
  },
  header: {
    width: '100%',
    height: '83px',
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E5EA',
    color: '#000000',
    padding: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    '& .MuiTypography-root': {
      color: '#000000',
      fontWeight: 600,
      fontSize: '17px',
    },
    '& .MuiGrid-container': {
      alignItems: 'center',
    },
    '& $headerMeta': {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: 1.25,
      color: '#6b6b70',
    },
  },
  // Texto secundario del encabezado del chat de ruta (cliente · dirección, compañía):
  // va truncado a 2 líneas para no desbordar el alto fijo del header.
  headerMeta: {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    wordBreak: 'break-word',
  },
  headerText: {
    minWidth: 0,
    paddingRight: '40px !important',
  },
  headerTitle: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  avatar: {
    width: '48px',
    height: '48px',
    display: 'inline-block',
    border: 'none',
    marginTop: '0px',
    '& svg': {
      fontSize: '30px',
      marginTop: '8px',
      color: '#8E8E93'
    }
  },
  btnClose: {
    position: 'absolute',
    right: '27px',
    top: '5px',
    color: '#8E8E93',
    minWidth: '32px',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    padding: '4px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    '& svg': {
      fontSize: '24px'
    }
  },
  textCenter: {
    textAlign: 'center'
  },
  containerMessages: {
    overflow: 'auto',
    height: '330px',
    padding: '15px 15px 10px',
    display: 'block',
    textAlign: 'center',
    backgroundColor: '#FFFFFF',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D1D1D6',
      borderRadius: '2px',
      '&:hover': {
        background: '#AEAEB2',
      }
    }
  },
  messageContainer: {
    padding: '4px 0',
  },
  writingIndicatorMessage: {
    textAlign: 'left',
    padding: '8px 16px 0',
  },
  writingIndicatorBubble: {
    padding: '10px 14px',
    borderRadius: '16px',
    borderTopLeftRadius: '4px',
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: '#eaf5fc',
  },
}));

export default styles;